import { api } from '../../services/authService';

export const ORG_NAME_RULE = 'Letters, numbers, hyphens and underscores; cannot start with a number.';
export const sanitizeOrgName = (v) => v.replace(/[^a-zA-Z0-9_-]/g, '').replace(/^\d+/, '');

export const parsePublisherIds = (csv) =>
  String(csv || '')
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);

/** Platform-admin organization calls shared by the listing and detail pages. */
export const adminOrgsApi = {
  list: () => api.get('/api/v2/admin/organizations').then((r) => r.data),
  create: (payload) => api.post('/api/v2/organizations/', payload).then((r) => r.data),
  update: (orgId, payload) => api.put(`/api/v2/organizations/${orgId}`, payload).then((r) => r.data),
  deactivate: (orgId) => api.delete(`/api/v2/organizations/${orgId}`).then((r) => r.data),
};

/** Backend detail as text: strings pass through, pydantic error lists are joined. */
export function apiErrorText(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg ?? d).join(' ');
  if (err?.response?.status === 502) {
    return 'Server returned 502 Bad Gateway. This usually means the Databricks or S3 setup for the organization failed; check backend logs.';
  }
  return err?.message || fallback;
}
